// Libraries
import React from 'react';

// Supermove
import {Styled} from '@supermove/components';
import {colors} from '@supermove/styles';
import {ViewStyleProp} from '@supermove/styles/types';

// Shared
import Text from '@shared/design/components/Text';

const SystemMessageContainer = Styled.View<{isWarning?: boolean}>`
  flex-direction: row;
  align-items: center;
  justify-content: center;
  background-color: ${({isWarning}) => (isWarning ? colors.orange.accent : colors.red.accent)};
  border-radius: 4px;
  padding-horizontal: 24px;
  padding-vertical: 8px;
`;

const SystemMessage = ({
  isWarning,
  containerStyle,
  children,
}: {
  isWarning?: boolean;
  containerStyle?: ViewStyleProp;
  children: React.ReactNode;
}) => {
  return (
    <SystemMessageContainer isWarning={isWarning} style={containerStyle}>
      <Text.Micro style={{color: isWarning ? colors.orange.status : colors.red.warning}}>
        {children}
      </Text.Micro>
    </SystemMessageContainer>
  );
};

export default SystemMessage;
